import { H3 } from '@h3/types';
import { request } from '@h3/request';

// 新增插件模板
const Add_Plugin_TemplateInfo_Url = '/v1/plugin/pluginTemplateInfo/add';
// 更新插件模板
const Update_Plugin_TemplateInfo_Url = '/v1/plugin/pluginTemplateInfo/update';
// 删除插件模板
const Delete_Plugin_TemplateInfo_Url = '/v1/plugin/pluginTemplateInfo/delete';
// 根据插件编码获取单个插件模板
const Get_Plugin_TemplateInfo_Url = '/v1/plugin/pluginTemplateInfo/get?code=';
// 批量获取插件模板
const Get_Plugin_TemplateInfos_Url = '/v1/plugin/pluginTemplateInfo/list';
// 增加插件模板实例
const Add_Plugin_Instance_Url = '/v1/plugin/plugininstance/add';
// 更新插件模板实例
const Update_Plugin_Instance_Url = '/v1/plugin/plugininstance/update';
// 删除插件模板实例
const Delete_Plugin_Instance_Url = '/v1/plugin/plugininstance/delete';
// 获取某个企业的插件模板实例
const Get_Plugin_Instance_Url = '/v1/plugin/plugininstance/listbyenginecode?engineCode=';
// 调用插件后端服务
const Invoke_Plugin_Server_Url = '/v2/plugin/invoke';

/**
 * 新增插件模板
 */
export const addPluginTemplateInfo = (pluginTemplateInfo: H3.Plugin.Next.IPluginTemplateInfo) => {
    return request<H3.Http.Response.H3ResponseV2Beta<boolean>>(Add_Plugin_TemplateInfo_Url, {
        method: 'post',
        data: pluginTemplateInfo,
        disableBizError: true,
    });
};

/**
 * 更新插件模板
 */
export const updatePluginTemplateInfo = (pluginTemplateInfo: H3.Plugin.Next.IPluginTemplateInfo) => {
    return request<H3.Http.Response.H3ResponseV2Beta<boolean>>(Update_Plugin_TemplateInfo_Url, {
        method: 'post',
        data: pluginTemplateInfo,
        disableBizError: true,
    });
};

/**
 * 删除插件模板
 */
export const removePluginTemplateInfo = (pluginCode: string) => {
    const url = `${Delete_Plugin_TemplateInfo_Url}?code=${pluginCode}`;
    return request<H3.Http.Response.H3ResponseV2Beta<boolean>>(url, {
        method: 'post',
        disableBizError: true,
    });
};

/**
 * 根据插件编码获取单个插件模板
 */
export const getPluginTemplateInfoByCode = (pluginCode: string) => {
    const url = `${Get_Plugin_TemplateInfo_Url}${pluginCode}`;
    return request<H3.Http.Response.H3ResponseV2Beta<H3.Plugin.Next.IPluginTemplateInfo>>(url, {
        method: 'get',
    });
};

/**
 * 批量获取插件模板
 */
export const getPluginTemplateInfos = (from: number, to: number) => {
    const params = {
        from,
        to,
    };
    return request<H3.Http.Response.H3ResponseV2Beta<H3.Plugin.Next.IPluginTemplateInfo[]>>(
        Get_Plugin_TemplateInfos_Url,
        {
            method: 'post',
            data: params,
            disableBizError: true,
        },
    );
};

/**
 * 新增插件模板实例
 */
export const addPluginInstance = (params: H3.Plugin.Next.IPluginTemplateInfo) => {
    return request<H3.Http.Response.H3ResponseV2Beta<boolean>>(Add_Plugin_Instance_Url, {
        method: 'post',
        data: params,
        disableBizError: true,
    });
};

/**
 * 更新插件模板实例
 */
export const updatePluginInstance = (pluginInstanceInfo: H3.Plugin.Next.IPluginInstance) => {
    return request<H3.Http.Response.H3ResponseV2Beta<boolean>>(Update_Plugin_Instance_Url, {
        method: 'post',
        data: pluginInstanceInfo,
        disableBizError: true,
    });
};

/**
 * 删除插件模板实例
 */
export const removePluginInstance = (engineCode: string, pluginCode: string) => {
    const params = {
        engineCode,
        code: pluginCode,
    };
    return request<H3.Http.Response.H3ResponseV2Beta<boolean>>(Delete_Plugin_Instance_Url, {
        method: 'post',
        data: params,
        disableBizError: true,
    });
};

/**
 * 批量获取插件实例
 */
export const getPluginInstances = (engineCode: string) => {
    const url = `${Get_Plugin_Instance_Url}${engineCode}`;
    return request<H3.Http.Response.H3ResponseV2Beta<H3.Plugin.Next.IPluginInstance[]>>(url, {
        method: 'get',
    });
};

/**
 * 调用插件后端服务
 */
export const invokePluginServer = (pluginCode: string, value: Record<string, any>, actionName: string) => {
    const params = {
        Code: pluginCode,
        ActionName: actionName,
        Value: value,
    };
    return request<H3.Http.Response.H3Response<any>>(Invoke_Plugin_Server_Url, {
        method: 'post',
        data: params,
        disableBizError: true,
    });
};
